var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.514a.5.5 0 0 1 0-1h7.027a.5.5 0 1 1 0 1H4.5zm0 2.513a.5.5 0 1 1 0-1h7.027a.5.5 0 1 1 0 1H4.5zM4.5 6a.5.5 0 0 1 0-1h7.027a.5.5 0 1 1 0 1H4.5z"
  })));
};
export default SvgHamburger;